"use client";

import { LogOut } from "lucide-react";

import { hardSignOut } from "@/lib/auth/clientSignOut";
import { cn } from "@/lib/utils";

/**
 * "Sign out" as the quiet way out of a screen that is about something else
 * (a suspended studio, a session that would not restore): gray text with
 * the LogOut icon, the subtle action link of design-guidelines §7. Both
 * suspended-studio screens drew it, one blue with no icon (2026-10-15).
 *
 * Not the account menu's row (a menu item, `AccountMenu`) and not
 * `SignOutContinueButton`, which signs out to carry on somewhere (an
 * invite for another account) and is that screen's main action.
 */
export default function SignOutLink({ callbackUrl = "/", className }) {
  return (
    <button
      type="button"
      onClick={() => hardSignOut(callbackUrl)}
      className={cn(
        "inline-flex items-center gap-1.5 text-sm font-medium text-gray-700 hover:text-gray-900",
        className
      )}
    >
      <LogOut className="h-4 w-4" aria-hidden />
      Sign out
    </button>
  );
}
